import { Layout } from "antd"
import {
  DefaultContent,
  DefaultHeader,
  DefaultSideBar,
} from "components/molecules/"
import React from "react"
import { Outlet } from "react-router-dom"
import styled from "styled-components"

const StyledLayout = styled(Layout)`
  min-height: 100vh;
`

export const DefaultLayout = () => {
  return (
    <StyledLayout className="layout">
      <DefaultHeader />

      <Layout>
        <DefaultSideBar />
        <DefaultContent>
          <Outlet />
        </DefaultContent>
      </Layout>
    </StyledLayout>
  )
}
